import { createContext } from 'react';
import { AdvertCardContextType } from '#advert/components/card';

const AdvertCardContext = createContext<AdvertCardContextType>(null);

export { AdvertCardContext };
